import { Slide } from '@/components/core/Slide';
import videoFile from './15-bubbles.webm';
import audioFile from './23-final-thoughts.mp3';

const autoNextDuration = 40000;
const transcript = `
 Er is vast nog veel meer te zeggen, maar er is nog veel te doen... dus laten we aan de slag gaan!  

Deze dag draait vooral om creatief denken. Denk eens echt out of the box, 
op manieren waarop AI-systemen dat nu nog niet kunnen. 
En ontdek de kracht van samenwerken in teams met verschillende achtergronden. 
Netwerken, leren van anderen, en je laten verbazen door wat er ontstaat als je openstaat voor nieuwe ideeën.  

Ik hoop op een dag vol bijzondere ideeën en vooral veel plezier.  

En nu wil ik toch nog graag afsluiten met mijn song... Die is toch gewoon leuk Jonathan...

Dank jullie wel! 
`;

export const slide = () => {
  return (
    <Slide
      notes={transcript}
      autoNext={autoNextDuration}
      audio={audioFile}
      visualizer="full"
      transition="fade"
      background={{
        video: videoFile,
      }}
    >
      <div className="absolute inset-0 z-0" />
    </Slide>
  );
};
